export default function ComingSoon() {
  return (
      <div className="flex w-full min-h-screen bg-hero bg-center bg-no-repeat bg-cover">
          <div className="absolute bottom-6 right-6 md:bottom-32 md:right-10">
              <p className="font-wantCoffee text-3xl md:text-5xl 2xl:text-7xl uppercase bg-primary text-white px-8 py-4 rounded-xl shadow-lg">
                  COMING SOON
              </p>
          </div>
      </div>
  );
}